import { Observable } from 'rxjs';
import * as URI from 'uri-js';

import { Inject, Injectable, InjectionToken } from '@angular/core';

import { HttpService } from '../http/http.service';
import { FeatureFlags } from '../interfaces';

export const FEATURE_FLAG_API = new InjectionToken<string>(
  'please provide FEATURE_FLAG_API in the provider list of your module'
);
@Injectable()
export class FeatureflagServiceV2 {
  private isEnabledEndpoint: string;
  constructor(
    private httpService: HttpService,
    @Inject(FEATURE_FLAG_API) baseUrl: string
  ) {
    this.isEnabledEndpoint = URI.resolve(baseUrl, '/api/featureFlag/isEnabled');
  }

  isEnabled(
    accountKey: string,
    featureFlagPath: FeatureFlags
  ): Observable<boolean> {
    console.log(this.isEnabledEndpoint);

    return this.httpService.get(this.isEnabledEndpoint, undefined, {
      headers: {
        accountKey,
        featureFlagPath,
      },
    });
  }
}
